import react, { useEffect } from "react";
import cssClasses from "./ShowQrCode.module.css";
import defaultImage from "../../Assets/Images/Common/defaultEventImage.svg";
import mapImage from "../../Assets/Images/Common/map.svg";
//*MUI
import { Box, Card, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";

//*files
import logo from "../../Assets/Images/SideMenu/vjLogo.jpg";
// import justImage from "../Assets/Images/Login/JustImage.svg";
// import barcodeImage from "../Assets/Images/Login/barcodeimg.svg";

const useStyles = makeStyles((theme) => ({
	FirstLabel: {
		fontSize: "1.4rem",
		lineHeight: "1.8rem",
		fontFamily: "Inter-Medium",
		color: "#98A2B3",
		// marginBottom:"1rem",
		// width:"100px",
		// !!sarita changes
		width: "47%",
		textAlign: "left",
	},
	SecondLabel: {
		fontSize: "1.4rem",
		lineHeight: "2.2rem",
		fontFamily: "Inter-Regular",
		color: "#000000",
		whiteSpace: "nowrap",
		// padding:"0 1rem",
		// width:"250px",
	},
	RowDiv: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "flex-start",
		marginBottom: "0.5rem",
	},
	ThirdLabel: {
		fontSize: "1.4rem",
		lineHeight: "2.2rem",
		fontFamily: "Inter-SemiBold",
		color: "#000000",
		// padding:"0 1rem",
		textAlign: "left",
		// width:"250px",
	},
}));
export default function ShowQrCode({ qrData }) {
	const classes = useStyles();

	// const qrData = {
	//   eventImage: "",
	//   projectName: "Novaglobal",
	//   tokenDisplayNumber: "20220203-GT02-0001",
	//   eventName: "Sarita test",
	//   tokenTitle: "GT",
	//   eventDateTime: "Wed 1,Feb",
	//   projectLocation: "Pune",
	//   tokenIssued: "1-Feb-2023",
	//   tokenAmount: "₹3000",
	// };
	useEffect(() => {
		console.log("qr data", qrData);
	}, []);
	return (
		// <div style={{ position: "relative", width: "95%", margin: "0 auto" }}>
		//   <div className={cssClasses.wrapperQr}>
		//     <div className={cssClasses.wrapperEventDetails}>
		//       <div>
		//         {qrData.eventImage === "" ? (
		//           <img
		//             className={cssClasses.eventImage}
		//             src={defaultImage}
		//             alt={"eventImage"}
		//           ></img>
		//         ) : (
		//           <img
		//             className={cssClasses.eventImage}
		//             src={process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + qrData.eventImage}
		//             alt={"eventImage"}
		//           ></img>
		//         )}
		//       </div>
		//       <div className={cssClasses.eventDetails}>
		//         {/* <span className={cssClasses.projectName}>{qrData.projectName}</span> */}
		//         <span className={cssClasses.projectName}>{qrData.eventName}</span>
		//         {/* <span className={cssClasses.eventName}>{qrData.eventName}</span> */}
		//         <span className={cssClasses.eventDate}>{qrData.eventDateTime}</span>
		//         {/* <span className={cssClasses.projectLocation}>
		//           {qrData.projectLocation}
		//           <a
		//             href="http://maps.google.com/?q=1200 Pennsylvania"
		//             target="_blank"
		//           >
		//             <img
		//               style={{
		//                 width: "2rem",
		//                 height: "2rem",
		//                 objectFit: "contain",
		//                 marginLeft: "1rem",
		//               }}
		//               src={mapImage}
		//               alt="map"
		//             ></img>
		//           </a>
		//         </span> */}
		//       </div>
		//     </div>
		//     <div className={cssClasses.borderBottom}>
		//       <div className={cssClasses.circleLeft}></div>
		//       <div className={cssClasses.circleRight}></div>
		//     </div>
		//     <div className={cssClasses.wrapperTokenDetails}>
		//       <div>
		//         <img
		//           className={cssClasses.eventImage}
		//           src={qrData.qrCode}
		//           alt={"qrCode"}
		//         ></img>
		//       </div>
		//       <div className={cssClasses.tokenDetails}>
		//         <span className={cssClasses.tokenTitle}>{qrData.tokenTitle}</span>
		//         {qrData.paidAmount > 0 &&
		//           <span className={cssClasses.tokenNumber}>
		//             {qrData.tokenDisplayNumber}
		//           </span>
		//         }
		//       </div>
		//     </div>
		//     <div className={cssClasses.borderBottom}>
		//       <div className={cssClasses.circle2Left}></div>
		//       <div className={cssClasses.circle2Right}></div>
		//     </div>
		//     <div className={cssClasses.tokenPaymentDetails}>
		//       <span className={cssClasses.tokenAmountTitle}>Token Amount</span>
		//       <span
		//         style={{
		//           display: "flex",
		//           flexDirection: "column",
		//         }}
		//       >
		//         <span className={cssClasses.tokenAmount}>₹{' '}{qrData.tokenAmount}</span>
		//         <span className={cssClasses.tokenAmount}>{qrData.tokenIssued}</span>
		//       </span>
		//     </div>
		//   </div>
		// </div>
		<Box
		// margin={"auto"}
		// width={'435px'}
		>
			<Card
				variant="outlined"
				display={"flex"}
				flexDirection={"column"}
				justifyContent={"center"}
				alignItems={"center"}
				sx={{
					borderRadius: 2,
					p: 2,
					// minWidth: 300,
				}}
			>
				<Box p={"1rem"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
					<img src={logo} alt="VJ-Logo" style={{ width: "20rem" }} />
				</Box>
				<Box
					display={"flex"}
					justifyContent={"center"}
					style={{
						padding: " 1rem 0rem 2rem 1rem",
					}}
				>
					{/* <img src={justImage} alt="Event-Image" style={{width:'300px'}}/> */}
					{qrData.eventImage === "" ? (
						<img className={cssClasses.eventImage} src={defaultImage} alt="Event" style={{ width: "30rem" }}></img>
					) : (
						<img
							className={cssClasses.eventImage}
							src={process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + qrData.eventImage}
							alt="Event"
							style={{
								width: "30rem",
								height: "14rem",
								objectFit: "fill",
								borderRadius: "1.5rem",
							}}
						></img>
					)}
				</Box>

				<Divider />

				<Box margin={"2rem 1rem"}>
					<Box className={classes.RowDiv}>
						<Box className={classes.FirstLabel}>Token :</Box>
						<Box className={classes.ThirdLabel}>{qrData.tokenTitle}</Box>
					</Box>
					<Box className={classes.RowDiv}>
						<Box className={classes.FirstLabel}>Event :</Box>
						<Box className={classes.ThirdLabel}>{qrData.eventName} </Box>
					</Box>
					<Box className={classes.RowDiv}>
						<Box className={classes.FirstLabel}>Date :</Box>
						<Box className={classes.SecondLabel}> {qrData.eventDateTime}</Box>
					</Box>
				</Box>

				<Divider />

				<Box margin={"2rem 1rem"}>
					<Box className={classes.RowDiv}>
						<Box className={classes.FirstLabel}>Token Amount :</Box>
						<Box className={classes.SecondLabel}>
							{" "}
							<span className={classes.ThirdLabel}>₹</span>
							{qrData.tokenAmount}
						</Box>
					</Box>
					<Box className={classes.RowDiv}>
						<Box className={classes.FirstLabel}>Issued Date:</Box>
						<Box className={classes.SecondLabel}>{qrData.tokenIssued}</Box>
					</Box>
				</Box>

				{qrData.paidAmount === qrData.amount && (
					<>
						<Divider />
						<Box className={classes.RowDiv} margin={"2rem 1rem"}>
							<Box
								style={{
									width: "47%",
									textAlign: "left",
								}}
							>
								{/* <img src={barcodeImage} alt="Token-Barcode" style={{width:'9rem'}}/> */}
								<img className={cssClasses.eventImage} src={qrData.qrCode} alt={"qrCode"}></img>
							</Box>

							<Box mt={2}>
								<Box className={classes.ThirdLabel} padding={"0 !important"}>
									{qrData.tokenTitle}
								</Box>
								<Box className={classes.ThirdLabel} padding={"0 !Important"}>
									VJ{qrData.tokenDisplayNumber}
								</Box>
							</Box>
						</Box>
					</>
				)}
			</Card>
		</Box>
	);
}
